export const dateConfig = {
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	month: 'long',
	year: 'numeric',
};

export const headConfig = {
	month: 'long',
	year: 'numeric',
} as const;




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/gcr-pressrelease/GcrPressReleaseSettings.ts